import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import AccountingContainer from './AccountingContainer'


const AccountingRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><AccountingContainer></AccountingContainer></Provider>
}

AccountingRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default AccountingRoot
